module.exports = __webpack_public_path__ + "static/media/service-contact.6d3ee720.svg";